import React from 'react'
import type { SvgIconProps } from '@mui/material'

import ChevronRight from '@mui/icons-material/ChevronRight'
import EditRounded from '@mui/icons-material/EditRounded'
import SendRounded from '@mui/icons-material/SendRounded'
import CancelScheduleSend from '@mui/icons-material/CancelScheduleSend'
import FactCheck from '@mui/icons-material/FactCheck'
import SaveOutlined from '@mui/icons-material/SaveOutlined'
import Add from '@mui/icons-material/Add'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import Search from '@mui/icons-material/Search'
import PhoneIphoneOutlined from '@mui/icons-material/PhoneIphoneOutlined'
import PhoneOutlined from '@mui/icons-material/PhoneOutlined'
import DesktopMacOutlined from '@mui/icons-material/DesktopMacOutlined'
import CloseOutlined from '@mui/icons-material/CloseOutlined'
import Info from '@mui/icons-material/Info'
import ColorLensOutlined from '@mui/icons-material/ColorLensOutlined'
import ColorLens from '@mui/icons-material/ColorLens'
import FavoriteBorder from '@mui/icons-material/FavoriteBorder'
import Favorite from '@mui/icons-material/Favorite'
import Delete from '@mui/icons-material/Delete'
import ContentCopy from '@mui/icons-material/ContentCopy'
import Share from '@mui/icons-material/Share'
import PersonAdd from '@mui/icons-material/PersonAdd'
import AccountCircle from '@mui/icons-material/AccountCircle'
import Menu from '@mui/icons-material/Menu'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline'
import CheckCircle from '@mui/icons-material/CheckCircle'
import CircleOutlined from '@mui/icons-material/CircleOutlined'
import PlayCircleFilledWhiteOutlined from '@mui/icons-material/PlayCircleFilledWhiteOutlined'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import History from '@mui/icons-material/History'
import Lock from '@mui/icons-material/Lock'
import LocalLibraryOutlined from '@mui/icons-material/LocalLibraryOutlined'
import SchoolOutlined from '@mui/icons-material/SchoolOutlined'
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Check from '@mui/icons-material/Check'
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline'
import PlayArrow from '@mui/icons-material/PlayArrow'
import FilterList from '@mui/icons-material/FilterList'
import FilterNone from '@mui/icons-material/FilterNone'
import SupervisorAccount from '@mui/icons-material/SupervisorAccount'
import CancelOutlined from '@mui/icons-material/CancelOutlined'
import Replay from '@mui/icons-material/Replay'
import AccessAlarm from '@mui/icons-material/AccessAlarm'
import Schedule from '@mui/icons-material/Schedule'
import PriorityHigh from '@mui/icons-material/PriorityHigh'
import MoreHoriz from '@mui/icons-material/MoreHoriz'
import PriceCheck from '@mui/icons-material/PriceCheck'
import AddAlarm from '@mui/icons-material/AddAlarm'
import NotificationsActive from '@mui/icons-material/NotificationsActive'
import NotificationAdd from '@mui/icons-material/NotificationAdd'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import ArrowDownward from '@mui/icons-material/ArrowDownward'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import PlaylistAdd from '@mui/icons-material/PlaylistAdd'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined'
import OpenInNew from '@mui/icons-material/OpenInNew'
import MailOutlined from '@mui/icons-material/MailOutlined'
import MarkunreadMailboxOutlined from '@mui/icons-material/MarkunreadMailboxOutlined'
import AddBusinessOutlined from '@mui/icons-material/AddBusinessOutlined'
import Fastfood from '@mui/icons-material/Fastfood'
import Publish from '@mui/icons-material/Publish'
import AutoAwesome from '@mui/icons-material/AutoAwesome'
import Map from '@mui/icons-material/Map'
import LinkOff from '@mui/icons-material/LinkOff'
import RecordVoiceOverOutlined from '@mui/icons-material/RecordVoiceOverOutlined'
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined'
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined'

export type IconName =
	| 'ChevronRight'
	| 'EditRounded'
	| 'SendRounded'
	| 'CancelScheduleSend'
	| 'FactCheck'
	| 'SaveOutlined'
	| 'Add'
	| 'DeleteOutline'
	| 'Search'
	| 'PhoneIphoneOutlined'
	| 'PhoneOutlined'
	| 'DesktopMacOutlined'
	| 'CloseOutlined'
	| 'Info'
	| 'ColorLensOutlined'
	| 'ColorLens'
	| 'FavoriteBorder'
	| 'Favorite'
	| 'Delete'
	| 'ContentCopy'
	| 'Share'
	| 'PersonAdd'
	| 'AccountCircle'
	| 'Menu'
	| 'ChevronLeft'
	| 'ChevronRight'
	| 'CheckCircleOutline'
	| 'CheckCircle'
	| 'CircleOutlined'
	| 'PlayCircleFilledWhiteOutlined'
	| 'History'
	| 'Lock'
	| 'AccountCircle'
	| 'LocalLibraryOutlined'
	| 'SchoolOutlined'
	| 'AccountCircleOutlined'
	| 'InfoOutlined'
	| 'Check'
	| 'PlayCircleOutline'
	| 'PlayArrow'
	| 'FilterList'
	| 'FilterNone'
	| 'SupervisorAccount'
	| 'CancelOutlined'
	| 'Replay'
	| 'AccessAlarm'
	| 'Schedule'
	| 'PriorityHigh'
	| 'MoreHoriz'
	| 'PriceCheck'
	| 'AddAlarm'
	| 'NotificationsActive'
	| 'NotificationAdd'
	| 'KeyboardArrowUp'
	| 'KeyboardArrowDown'
	| 'KeyboardArrowRight'
	| 'ArrowUpward'
	| 'ArrowDownward'
	| 'PlaylistAdd'
	| 'Visibility'
	| 'VisibilityOff'
	| 'PictureAsPdfOutlined'
	| 'OpenInNew'
	| 'MailOutlined'
	| 'MarkunreadMailboxOutlined'
	| 'AddBusinessOutlined'
	| 'Fastfood'
	| 'Publish'
	| 'AutoAwesome'
	| 'LinkOff'
	| 'Map'
	| 'RecordVoiceOverOutlined'
	| 'AccountBalanceOutlined'
	| 'StorefrontOutlined'

const iconDict: { [key in IconName]: (props?: SvgIconProps) => JSX.Element } = {
	ChevronRight: (props) => <ChevronRight {...props} />,
	EditRounded: (props) => <EditRounded {...props} />,
	SendRounded: (props) => <SendRounded {...props} />,
	CancelScheduleSend: (props) => <CancelScheduleSend {...props} />,
	FactCheck: (props) => <FactCheck {...props} />,
	SaveOutlined: (props) => <SaveOutlined {...props} />,
	Add: (props) => <Add {...props} />,
	DeleteOutline: (props) => <DeleteOutline {...props} />,
	LinkOff: (props) => <LinkOff {...props} />,
	Search: (props) => <Search {...props} />,
	PhoneIphoneOutlined: (props) => <PhoneIphoneOutlined {...props} />,
	PhoneOutlined: (props) => <PhoneOutlined {...props} />,
	DesktopMacOutlined: (props) => <DesktopMacOutlined {...props} />,
	CloseOutlined: (props) => <CloseOutlined {...props} />,
	Info: (props) => <Info {...props} />,
	ColorLensOutlined: (props) => <ColorLensOutlined {...props} />,
	ColorLens: (props) => <ColorLens {...props} />,
	FavoriteBorder: (props) => <FavoriteBorder {...props} />,
	Favorite: (props) => <Favorite {...props} />,
	Delete: (props) => <Delete {...props} />,
	ContentCopy: (props) => <ContentCopy {...props} />,
	Share: (props) => <Share {...props} />,
	PersonAdd: (props) => <PersonAdd {...props} />,
	AccountCircle: (props) => <AccountCircle {...props} />,
	Menu: (props) => <Menu {...props} />,
	ChevronLeft: (props) => <ChevronLeft {...props} />,
	CheckCircleOutline: (props) => <CheckCircleOutline {...props} />,
	CheckCircle: (props) => <CheckCircle {...props} />,
	CircleOutlined: (props) => <CircleOutlined {...props} />,
	PlayCircleFilledWhiteOutlined: (props) => <PlayCircleFilledWhiteOutlined {...props} />,
	History: (props) => <History {...props} />,
	Lock: (props) => <Lock {...props} />,
	LocalLibraryOutlined: (props) => <LocalLibraryOutlined {...props} />,
	SchoolOutlined: (props) => <SchoolOutlined {...props} />,
	AccountCircleOutlined: (props) => <AccountCircleOutlined {...props} />,
	InfoOutlined: (props) => <InfoOutlined {...props} />,
	Check: (props) => <Check {...props} />,
	PlayCircleOutline: (props) => <PlayCircleOutline {...props} />,
	PlayArrow: (props) => <PlayArrow {...props} />,
	FilterList: (props) => <FilterList {...props} />,
	FilterNone: (props) => <FilterNone {...props} />,
	SupervisorAccount: (props) => <SupervisorAccount {...props} />,
	CancelOutlined: (props) => <CancelOutlined {...props} />,
	Replay: (props) => <Replay {...props} />,
	AccessAlarm: (props) => <AccessAlarm {...props} />,
	Schedule: (props) => <Schedule {...props} />,
	PriorityHigh: (props) => <PriorityHigh {...props} />,
	MoreHoriz: (props) => <MoreHoriz {...props} />,
	PriceCheck: (props) => <PriceCheck {...props} />,
	AddAlarm: (props) => <AddAlarm {...props} />,
	NotificationsActive: (props) => <NotificationsActive {...props} />,
	NotificationAdd: (props) => <NotificationAdd {...props} />,
	KeyboardArrowUp: (props) => <KeyboardArrowUp {...props} />,
	KeyboardArrowDown: (props) => <KeyboardArrowDown {...props} />,
	KeyboardArrowRight: (props) => <KeyboardArrowRight {...props} />,
	ArrowUpward: (props) => <ArrowUpward {...props} />,
	ArrowDownward: (props) => <ArrowDownward {...props} />,
	PlaylistAdd: (props) => <PlaylistAdd {...props} />,
	Visibility: (props) => <Visibility {...props} />,
	VisibilityOff: (props) => <VisibilityOff {...props} />,
	PictureAsPdfOutlined: (props) => <PictureAsPdfOutlined {...props} />,
	OpenInNew: (props) => <OpenInNew {...props} />,
	MailOutlined: (props) => <MailOutlined {...props} />,
	MarkunreadMailboxOutlined: (props) => <MarkunreadMailboxOutlined {...props} />,
	AddBusinessOutlined: (props) => <AddBusinessOutlined {...props} />,
	Fastfood: (props) => <Fastfood {...props} />,
	Publish: (props) => <Publish {...props} />,
	AutoAwesome: (props) => <AutoAwesome {...props} />,
	Map: (props) => <Map {...props} />,
	RecordVoiceOverOutlined: (props) => <RecordVoiceOverOutlined {...props} />,
	AccountBalanceOutlined: (props) => <AccountBalanceOutlined {...props} />,
	StorefrontOutlined: (props) => <StorefrontOutlined {...props} />,
}

export default iconDict
